import { render, staticRenderFns } from "./BaseIcon.vue?vue&type=template&id=0c2f4f95&"
import script from "./BaseIcon.vue?vue&type=script&lang=js&"
export * from "./BaseIcon.vue?vue&type=script&lang=js&"
import style0 from "./BaseIcon.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports